// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saved-images-app-width {
    width: 840px;
}

.thumbs-style .carousel .thumbs-wrapper {
    overflow-x: scroll;
}

.thumb {
    height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/saved_images_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".saved-images-app-width {\n    width: 840px;\n}\n\n.thumbs-style .carousel .thumbs-wrapper {\n    overflow-x: scroll;\n}\n\n.thumb {\n    height: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
